import React, { Component, useState } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import "../CaseSelector/CaseSelector.css";
import "./Risks.css";
import { numberWithCommas } from "../../util";
import axios from "axios";
import { apiUri } from "../../config";
import TableGrid from "../../common/components/TableGrid/tableGrid";
import { risksSelectorColumns } from '../../common/components/TableGrid/tableColumn/RisksSelectorColumns';
import Modal from "react-responsive-modal";
import styled from 'styled-components';
import CheckboxList from '../../common/components/CheckboxList';
import { FaAngleLeft, FaAngleRight, FaAngleDoubleLeft, FaAngleDoubleRight, FaTimes, FaSearch } from 'react-icons/fa';
import "../Purchases/Disclosure.css";
import Disclosure from "../../dandos/components/Disclosure";
import { Button } from "../../common/components/Button";
import RiskToolDisclosure from '../../ace/Disclosure';

const ButtonHolder = styled.div`
	margin-top: 10px;
`;

const RightSideButton = styled(Button)`
	float: right;
`;

const LeftSideButton = styled(Button)`
	marginright: 15px;
`;
const PaginationList = styled.ul`
	float: right;
	color: white;
	font-family: "GothamLight";
	display: flex;
	padding-left: 0;
	list-style: none;
	padding-right: 50px;
	border-radius: .25rem;
	
	@media print {
		color: black;
	}
`;

const PaginatedItem = styled.li`
	padding-right: 4px;
	font-size: 14px;
	cursor: pointer;
	// display: ${props => props.disabled ? 'none' : ''};
	display: block;
	// color: #83BED3;
	color: ${props => props.disabled ? '#969292' : '#e6e8e4'};
	// pointer-events: none;
	pointer-events: ${props => props.disabled ? 'none' : 'pointer'};
	opacity: ${props => props.disabled ? '0.6' : '1'};
`;

const SelectedPaginatedItem = styled(PaginatedItem) `
	// color: BLUE;
	color: #83BED3;
`;

const marketOptions = ['NASDAQ', 'NasdaqCM', 'NasdaqGM', 'NasdaqGS', 'NYSE', 'NYSEAM']
const sectorOptions = ['Communication Services', 'Consumer Discretionary', 'Consumer Staples', 'Energy', 'Financials', 'Health Care', 'Industrials', 'Information Technology', 'Materials', 'Real Estate', 'Utilities']
const capOptions = [, 'Mega', 'Large', 'Mid', 'Small', 'Micro', 'Nano']

const caps = 
	{
	'Mega' : {
		'min': 200000000000,
		'max' : 10000000000000
	},'Large' : {
		'min': 10000000000,
		'max' : 200000000000
	},'Mid' : {
		'min': 2000000000,
		'max' : 10000000000
	},'Small' : {
		'min': 250000000,
		'max' : 2000000000
	},'Micro' : {
		'min': 50000000,
		'max' : 250000000
	},'Nano' : {
		'min': 0,
		'max' : 50000000
	}
};



class MyCases extends Component {
	constructor(props) {
		super(props);
		this.state = {
			openBlock: false,
			jsonResponse:{},
			myCasesArray:[],
			currentPage: 1,
			totalCasesPerPages:40,
			totalPagesToShow:9,
			sortValue:'',
			sortOrder:'',
			searchValue:'',
			selectedCase: null,
			buttonDisabled : false,
			selectValues: {
				'market' : '',
				'sector' : '',
				'cap' : ''
			}
			
		};

		this.onCloseBlockModal = this.onCloseBlockModal.bind(this);
		this.onPurchaseClick = this.onPurchaseClick.bind(this);
		this.goToCaseHandler = this.goToCaseHandler.bind(this); 
		this.handleClick = this.handleClick.bind(this);
		this.getMyCases = this.getMyCases.bind(this);
		this.updateSearchValue = this.updateSearchValue.bind(this);
		this.handleClear = this.handleClear.bind(this);
		this.handleSearch = this.handleSearch.bind(this);
		this.handleSelect = this.handleSelect.bind(this);
		this.handleSorting = this.handleSorting.bind(this);
		this.updateSelectValue = this.updateSelectValue.bind(this);
		this.onRiskSelect = this.onRiskSelect.bind(this);
		this.purchaseRisk = this.purchaseRisk.bind(this);
	}

	

	componentWillMount(){
		this.getMyCases() 
	}
	componentDidMount(){
		localStorage.removeItem('searchValue');
		localStorage.removeItem('sortParams');
	}
	getMyCases(){
		axios
			.get(apiUri+"/risks/")
			.then(res =>{
				this.setState({
					jsonResponse: res.data,
					myCasesArray: res.data.content
				})
			}
			)
			.catch(err => {
				console.log(err);
			});
	}

	handleClick(event) {
		this.setState({
			currentPage: Number(event)
		});
		//console.log('event');
		//console.log(event);
	}

	goToCaseHandler = caseId => {
		this.props.history.push("/cases/" + caseId);
		sessionStorage.setItem('currentPage',this.state.currentPage)
	};

	getOrderDate = data => {
 
		if (data) {
			var date = new Date(data);
			var year = date.getFullYear();
			var month = (1 + date.getMonth()).toString().padStart(2, "0");
			var day = date
				.getDate()
				.toString()
				.padStart(2, "0");
			return year + "-" + month + "-" + day;
		} else {
		return "";
		}
	};

	handleSorting = (key,order) => {
		if(order==="asc"){
			
			if(key === "classPeriodEnd" || key === "classPeriodStart" || key === "dateFiled"){
				this.setState({myCasesArray:this.state.myCasesArray.sort((a,b) => {
					return (this.getOrderDate(a[key]) > this.getOrderDate(b[key])) ? 1 :
					((this.getOrderDate(b[key]) > this.getOrderDate(a[key])) ? -1 : 0)}),
					sortValue:key,
					sortOrder: order
				});
			}else{
			
				this.setState({myCasesArray:this.state.myCasesArray.sort((a,b) => {
					return (a[key] > b[key]) ? 1 : ((b[key] > a[key]) ? -1 : 0)}),
					sortValue:key,
					sortOrder: order
				});
			}   
		}else{
			if(key === "classPeriodEnd" || key === "classPeriodStart" || key === "dateFiled"){
				this.setState({myCasesArray:this.state.myCasesArray.sort((a,b) => {
					return (this.getOrderDate(a[key]) < this.getOrderDate(b[key])) ? 1 :
					((this.getOrderDate(b[key]) < this.getOrderDate(a[key])) ? -1 : 0)}),
					sortValue:key,
					sortOrder: order
				});
			}else{
			
				this.setState({myCasesArray:this.state.myCasesArray.sort((a,b) => {
					return (a[key] < b[key]) ? 1 : ((b[key] < a[key]) ? -1 : 0)}),
					sortValue:key,
					sortOrder: order
				});
			}
		}
	}  

	resetData() {
		this.setState({
				myCasesArray : this.state.jsonResponse.content
			});
	}
	handleSearch() {
		this.handleClick(1);
		if(this.state.searchValue){
			this.setState({
				myCasesArray:this.state.myCasesArray.filter(item => {
					return (
						(item.riskName
						.toLowerCase()
						.indexOf(this.state.searchValue.toLowerCase()) !== -1) ||
						(item.symbol
						.toLowerCase()
						.indexOf(this.state.searchValue.toLowerCase()) !== -1)
					);
				})
			})
			sessionStorage.setItem('tempSearchValue',this.state.searchValue);
		}
	}

	handleSelect() {
		//console.log('this.state.selectValues');
		//console.log(this.state.selectValues);
		
		//console.log('this.state.myCasesArray.length');
		//console.log(this.state.myCasesArray.length);

		var casesArray = this.state.myCasesArray;
		if(this.state.selectValues.market.length > 0) {
			casesArray = casesArray.filter(item => {
				return (
					(item.market
					.toLowerCase()
					.indexOf(this.state.selectValues.market.toLowerCase()) !== -1) 
				)
			});

		}
		if(this.state.selectValues.sector.length > 0) {
			casesArray = casesArray.filter(item => {
				return (
					(item.gicsSectorName
					.toLowerCase()
					.indexOf(this.state.selectValues.sector.toLowerCase()) !== -1) 
				)
			});

		}
		/*
		var myCap = 
		//console.log('this.state.selectValues.cap');
		//console.log(this.state.selectValues.cap);
		//console.log(caps);
		
		//console.log('caps[this.state.selectValues.cap].min');
		//console.log(caps[this.state.selectValues.cap].min);
		//console.log(caps[this.state.selectValues.cap]);
		*/
		if(this.state.selectValues.cap.length > 0) {
			casesArray = casesArray.filter(item => {
				return (
					(
						item.mcap >= caps[this.state.selectValues.cap].min &&
						item.mcap < caps[this.state.selectValues.cap].max 
				)
			)});

		}

		this.setState({myCasesArray:casesArray}, this.handleSearch);
		
		//console.log('casesArray.length end');
		//console.log(casesArray.length);		
		//console.log('this.state.myCasesArray.length end');
		//console.log(this.state.myCasesArray.length);
	}
	handleClear() {
		this.setState({ searchValue: '',  selectValues: {'market' : '','sector' : '','cap' : ''}, myCasesArray : this.state.jsonResponse.content});
		sessionStorage.removeItem('tempSearchValue')
	}
	keyPress(e) {
		if (e.keyCode === 13 || e.keyCode === 10) {
			this.handleSearch();
		}
	}
	updateSearchValue(evt) {
		this.setState({ searchValue: evt.target.value })
		if(evt.target.value.length===0){
			this.getMyCases();
		}
	}

	updateSelectValue(cat, val) {
		//console.log('cat')
		//console.log(cat)
		//console.log('val')
		//console.log(val)
		this.setState({ myCasesArray: this.state.jsonResponse.content, selectValues:{...this.state.selectValues, [cat]:val} },this.handleSelect)
		
	}

	onRiskSelect = (risk) => {
		
		if (risk.caseId !== null) {
			this.props.history.push("/cases/" + (parseInt(risk.caseId, 10)));

		} else {
			this.purchaseRisk(risk);
		}
	};

	onCloseBlockModal = () => {
		this.setState({ openBlock: false });
	}
	onPurchaseClick = (risk) => {
		//console.log('risk');
		//console.log(risk);
		
		if(!risk.caseId) {
			this.setState({ openBlock: true, selectedCase: risk});
		} else {
			this.onRiskSelect(risk);
		}

		
	}

	purchaseRisk() {
		if(this.state.selectedCase.riskId && !this.state.selectedCase.caseId && this.props.firmSettings.subscriber) {
			
			let riskId = this.state.selectedCase.riskId;
			const formData = new URLSearchParams();
			this.setState({ buttonDisabled: true});
			
			formData.append('purchaseType', 'LICENSED');
				axios.post(apiUri + "/riskPurchases/" + riskId , formData)
					.then(response => {
						/*
						dispatch(casesBought(riskId));
						if(!subscription) {
							dispatch(this.props.history.push("/cases/" + riskId));
						} else {
						 dispatch(this.props.history.push("/cases/" + riskId + "/classwide"));
						}
						*/
						//console.log(response);
						this.setState({ openBlock: false});
						this.handleClear();
						this.getMyCases();
						this.setState({ buttonDisabled: false});
						if (response.data && response.data.statusCode >= 200 && response.data.statusCode <= 210) {
							sessionStorage.setItem('DANDO',true);
							this.goToCaseHandler(response.data.content.dandoId);

						}
					});
			
		}
	}

	componentDidUpdate(){
		window.onpopstate  = (e) => {
			var tempSearchValue = sessionStorage.getItem('tempSearchValue')
			if(tempSearchValue){
				setTimeout(()=>{
					this.setState({
							myCasesArray:this.state.myCasesArray.filter(item => {
								return (   
										(item.riskName
											.toLowerCase()
											.indexOf(tempSearchValue.toLowerCase()) !== -1) ||
										(item.symbol
											.toLowerCase()
											.indexOf(tempSearchValue.toLowerCase()) !== -1) 
									);
							})
					})
				},200)

				this.setState({ searchValue: tempSearchValue })
			}
			var currentPage = sessionStorage.getItem('currentPage');
			if(currentPage){
				setTimeout(()=>{
				this.setState({ currentPage: Number(currentPage) })
			},50)
			}
		}
	}

	render() {
		let props = this.props;
		const { currentPage, totalCasesPerPages } = this.state;
		const indexOfLastTodo = currentPage * totalCasesPerPages;
		const indexOfFirstTodo = indexOfLastTodo - totalCasesPerPages;
		const myCasesList = this.state.myCasesArray.slice(indexOfFirstTodo, indexOfLastTodo);
		const pagesToDraw = [];
		const maxPages = Math.ceil(this.state.myCasesArray.length / totalCasesPerPages);
		const numOfPages = Math.min(maxPages, this.state.totalPagesToShow);
		const startPage = Math.max(1, Math.min(currentPage - Math.floor((this.state.totalPagesToShow-1)/2), maxPages - this.state.totalPagesToShow + 1));
		const endPage = Math.min(numOfPages + startPage-1, maxPages);
		const columns = risksSelectorColumns(this.onRiskSelect, this.onPurchaseClick);
		
		for (let page = startPage; page <= endPage; page++) {
			let currentPageSelection = currentPage === page;
			const p = currentPageSelection ?
				<SelectedPaginatedItem key={page} >
					<a onClick={() => this.handleClick(page)}>{page }</a>
				</SelectedPaginatedItem>
				:
				<PaginatedItem key={page}>
					<a onClick={() => this.handleClick(page)}>{page }</a>
				</PaginatedItem>;
			pagesToDraw.push(p);
		}

		const disabledOnFirstPageClass = currentPage === 1;
		const disabledOnLastPage = currentPage === maxPages;

		return (
			<div>
				<React.Fragment>
					<table style={{
										width: "95%"
									}}>
						<tr>
							<td className={"selectTd"} >
								<div className={"selectDivBox"}>
									U.S. Exchange <br />
									<CheckboxList
										options = {marketOptions} 
										group = "market"
										onChanger={this.updateSelectValue} />
								</div>

								<div className={"selectDivBox"}>
									Sector <br />
									<CheckboxList
										options = {sectorOptions} 
										group = "sector"
										onChanger={this.updateSelectValue} />
								</div>
								
								<div className={"selectDivBox"}>
									Cap Size <br />
									<CheckboxList
										options = {capOptions} 
										group = "cap"
										onChanger={this.updateSelectValue} />
								</div>
							</td>
							<td style={{
										width: "90%",
										verticalAlign: "top"
									}}>


								<div
									style={{ display: "flex", justifyContent: "space-between" }}
									className={"CaseSelectorTitle"}
								>
									<span>ACE Database</span>   

									<div
									style={{
										display: "flex",
										justifyContent: "space-between",
										width: "180"
									}}
									>
										<div
											style={{
											position: "relative",
											width: "207px",
											height: "29px",
											top: "-1px",
											backgroundColor: "#83bed3",
											border: "1px solid rgb(90, 154, 176)",
											borderRadius: "14.5px"
											}}
										>
											<input
												id="search"
												type="text"
												className="searchBox"
												onKeyDown={e => this.keyPress(e)}
												value={this.state.searchValue}
												placeholder="Search"
												onChange={this.updateSearchValue}
											/>
											{this.state.searchValue && (
											<span className="clearIcon" onClick={this.handleClear}>
												x
											</span>
											)}
											<FaSearch className="searchBtn" onClick={this.handleSearch} />
										</div>
									</div>   
								</div>
								<TableGrid
									columns = {columns}
									data = {myCasesList || []}
									risksOnClick = {this.onRiskSelect}
									handleSort = {this.handleSorting}
									sortValue = {props.sortValue}
									sortOrder = {props.sortOrder}
								/>
							</td>
						</tr>
					</table>
					<div>
						{/* //  Privileged and Confidential model start */}
						<Modal
								open={this.state.openBlock}
								onClose={this.onCloseBlockModal}
								focusTrapped={true}
								styles={{ modal: {width: "60%", height: "80%", overflow: "hidden" } }}
							>
								<div className="ModalWindow modaladd">
									<FaTimes className="closeicon" onClick={this.onCloseBlockModal} />
									<br />
									<div className="modalHeading"></div>
									<div className="NavDivider"></div>
									{this.props.firmSettings.subscriber?

										<div>
											<div className="scrollingContainer">
												<Disclosure />
											</div>	
											<div className="NavDivider"></div>
											<div className="NavDivider"></div>
											<ButtonHolder>
												<ButtonHolder>
													<LeftSideButton
														hoverBorderColor="red"
														onClick={() => this.onCloseBlockModal()}
													>
														Decline
													</LeftSideButton>
													<RightSideButton
														hoverBorderColor="darkgreen"
														disabled={this.state.buttonDisabled}
														onClick={() =>
															this.purchaseRisk()
														}
														>
														License Report
													</RightSideButton>
												</ButtonHolder>
											</ButtonHolder>

										</div>
										: 
										<div>
											<RiskToolDisclosure />
											<button className='sar-btn close-btn' onClick={this.onCloseBlockModal}>Close</button>
										</div>
									}
								</div>
							</Modal>
						{/* //  Privileged and Confidential model end */}
					</div>
				</React.Fragment>

				{/* Custom PaginationList start*/}
				<PaginationList>
					<PaginatedItem disabled={disabledOnFirstPageClass} >
						<a disabled={disabledOnFirstPageClass} onClick={() => this.handleClick(1)}> <FaAngleDoubleLeft style={{
							fontSize: '16px',
						}} /> </a>
					</PaginatedItem>
					<PaginatedItem disabled={disabledOnFirstPageClass}>
						<a disabled={disabledOnFirstPageClass} onClick={() => this.handleClick(currentPage - 1)}><FaAngleLeft style={{
							fontSize: '16px',
						}} /></a>
					</PaginatedItem>
					{pagesToDraw}
					<PaginatedItem disabled={true}>
						<a onClick={() => this.handleClick(maxPages)}>
							<span style={{
									fontSize: '16px',
								}} >
								of {maxPages}
							</span>
						</a>
					</PaginatedItem>
					<PaginatedItem disabled={disabledOnLastPage}>
						<a onClick={() => this.handleClick(currentPage + 1)}><FaAngleRight style={{
							fontSize: '16px',
						}} /></a>
					</PaginatedItem>
					<PaginatedItem disabled={disabledOnLastPage}>
						<a onClick={() => this.handleClick(maxPages)}> <FaAngleDoubleRight style={{
							fontSize: '16px',
						}} /> </a>
					</PaginatedItem>
				</PaginationList>
				{/* Custom PaginationList end*/}
			</div>
		);
	}
}

const mapStateToProps = state => {
	return {
		firmSettings:state.firmSettings,
	};
};

const mapDispatchToProps = dispatch => {
	return {
	
	};
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(withRouter(MyCases));



// WEBPACK FOOTER //
// ./src/components/Risks/Risks.js